import { useMemo } from "react";

import ReactEChartsCore from "echarts-for-react/lib/core";
import * as echarts from "echarts/core";

import {
  PieChart,
} from "echarts/charts";

import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  DatasetComponent
} from "echarts/components";

import {
  SVGRenderer
} from "echarts/renderers";

import type { MutableRefObject } from "react";
import type EChartsReactCore from "echarts-for-react";
import { ECBasicOption } from "echarts/types/dist/shared";

type StatusChartProps = {
  chartData: Array<{
    name: string
    value: number
  }> | undefined
  chartRef: MutableRefObject<EChartsReactCore | null>
  onSliceClick?: (name: string) => void
}

echarts.use([TitleComponent, TooltipComponent, LegendComponent, GridComponent, DatasetComponent, PieChart, SVGRenderer]);

export default function FirmwareChart({ chartData, chartRef, onSliceClick }: StatusChartProps) {

  const onEvents = useMemo(() => ({
    click: (params: { name?: string; componentType?: string }) => {
      if (params.componentType === "series" && params.name != null) {
        onSliceClick?.(params.name);
      }
    }
  }), [onSliceClick]);

  const totalChargersChartOptions: ECBasicOption = useMemo(() => {
    return {
      tooltip: {
        trigger: "item"
      },
      legend: {
        type: "scroll",
        orient: "horizontal",
        show: true,
        bottom: 0,
      },
      series: [
        {
          name: "Charger Status",
          type: "pie",
          radius: "70%",
          center: ["50%", "50%"],
          left: 0,
          top: 0,
          bottom: 20,
          avoidLabelOverlap: true,
          itemStyle: {
            borderColor: "#fff",
            borderWidth: 3
          },
          label: {
            show: true,
          },
          labelLine: {
            show: true
          },
          data: chartData
        }
      ]
    };
  }, [chartData]);

  return (
    <div id="StatusChart" style={{width: "100%"}}>
      <ReactEChartsCore
        echarts={echarts}
        ref={chartRef}
        option={totalChargersChartOptions}
        onEvents={onEvents}
        style={{width: "100%"}}
        opts={{renderer: "svg"}}
      />
    </div>
  );
}